<template>
    <div class="grabbing">
        <div class="grabbingItem">
            <div class="grabbingItem_start" v-if="isStart"  @click="grabbingLink(grabbingItem.id,grabbingItem.goods_id)">
                <div class="grabbingItem_img">
                    <img :src="weburl + grabbingItem.image" alt="">
                </div>
                <div class="grabbingItem_content">
                    <div class="grabbingItem_left">
                        <span>{{$t("crazy")}}<br>{{$t('grabbing')}}</span>
                    </div>
                    <div class="grabbingItem_right">
                        <div class="grabbingItem_title">
                            <h2>{{grabbingItem.title}}</h2>
                            <p>{{grabbingItem.description}}</p>
                        </div>
                        <div class="grabbingItem_time">
                            <p>{{$t("still_time")}}：<i>{{day}}</i>：<i>{{hour}}</i>：<i>{{minutes}}</i>：<i>{{second}}</i>
                            </p>
                            <div><span class="price">{{grabbingItem.price}}</span> <span
                                    class="join_grabbing">{{$t('join_grab')}}</span></div>
                            <div class="grabbing_num">
                                <s>￥{{grabbingItem.shop_price}}</s>
                                <p>{{$t('grab_num')}}<span class="num"><i class="num_speed"
                                                            :style="{'width': (grabbingItem.buy_num / grabbingItem.goods_num) * 100 + '%'}"></i></span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
            <div class="grabbingItem_end" v-else  @click="grabbingLink(grabbingItem.id,grabbingItem.goods_id)">
                <div class="grabbingItem_img">
                    <img :src="weburl + grabbingItem.image" alt="">
                </div>
                <div class="grabbingItem_content">
                    <div class="grabbingItem_left">
                        <span>{{$t('noYet')}}<br>{{$t("start")}}</span>
                    </div>
                    <div class="grabbingItem_right">
                        <div class="grabbingItem_title">
                            <h2>{{grabbingItem.title}}</h2>
                            <p>{{grabbingItem.description}}</p>
                        </div>
                        <div class="grabbingItem_time">
                            <p>{{$t(' start_time')+':'+timestamp(grabbingItem.start_time)}}</p>
                            <div><span class="price">{{grabbingItem.price}}</span> <span class="join_grabbing">{{$t('join_grab')}}</span></div>
                            <div class="grabbing_num">
                                <s>{{grabbingItem.shop_price}}</s>
                                <p>{$t('grab_num')}}<span class="num"><i class="num_speed" :style="{'width': (grabbingItem.buy_num / grabbingItem.goods_num) * 100 + '%'}"></i></span></p>
                            </div>
                        </div>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import grabbingItem from './grabbingItem';
    export default {
        name: "grabbing",
        props: ['grabbingItem'],
        data() {
            return {
                isStart: true,
                hour: '',
                minutes: '',
                second: '',
                day: '',
                count: null,
            }
        },
        created() {
            // console.log(this.grabbingItem);
            var timestamp = Date.parse(new Date());
            var now_time = timestamp / 1000;
            console.log(now_time);
            if (now_time > this.grabbingItem.start_time) {
                this.isStart = true;
                clearInterval(this.count);
                this.count = null;
                this.Countdown();
            } else {
                this.isStart = false;
                // this.timestamp(this.grabbingItem.start_time);
            }

        },
        methods: {
            Timer(m) {
                return m < 10 ? '0' + m : m;
            },
            days(h) {
                if (h < 10) {
                    return '00' + h;
                }
                else if (10 < h < 100) {
                    return '0' + h;
                }
            },
            Countdown() {
                const interval = 1000;
                this.count = setInterval(() => {
                    const timestamp = Date.parse(new Date());
                    // const now_time = timestamp / 1000;
                    const start_time = timestamp / 1000;
                    //获取的开始时间star小于 现在时间那么为正在进行中
                    // const end_time = this.grabbingItem.start_time <= now_time ? this.grabbingItem.end_time : this.grabbingItem.start_time;
                    const end_time = this.grabbingItem.end_time;
                    const diff_time = parseInt(end_time - start_time);// 倒计时时间差
                    // this.timestamp(diff_time);
                    this.day = this.days(Math.floor(diff_time / 3600 / 24));
                    this.hour = this.Timer(Math.floor(diff_time / 3600 % 24));
                    this.minutes = this.Timer(Math.floor((diff_time / 60 % 60)));
                    this.second = this.Timer(Math.floor((diff_time % 60)));
                }, interval);
            },
            timestamp(start_time) {
                const time = new Date(start_time * 1000);
                const year = time.getFullYear();
                const month = time.getMonth() + 1;
                const date = time.getDate();
                const h = time.getHours();
                const mm = time.getMinutes();
                const s = time.getSeconds();
                return year + "-" + this.Timer(month) + "-" + this.Timer(date) + "-" + this.Timer(h) + "-" + this.Timer(mm) + "-" + this.Timer(s);


            },
            grabbingLink(id,goods_id){
                // this.$router.push({path:`/grabbingDetail/${id}`});
                this.$router.push({ path: '/grabbingDetail', query: {id: id,goods_id: goods_id}});
            }
        },
        mounted() {
            /* clearInterval(this.count);
             this.count = null;
             this.Countdown();*/
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            }
        },
        destroyed() {
            clearInterval(this.count);
            this.count = null;
        }

    }
</script>

<style scoped lang="less">
    @import "../../assets/less/common.less";

    @bg-color: #e73533;
    @green-color: #32b16c;
    .grabbingItem {
        background: @font-primary;
        margin-bottom: 20px;
        .grabbingItem_content {
            width: @width;
            .box-sizing;
            padding: 10px 10px 10px 0;
        }
    }

    .grabbingItem_start, .grabbingItem_end, .grabbingItem {
        width: @width;
        .border-radius(10px);
    }

    .grabbingItem_img {
        width: @width;
        height: 200px;
        .border-radius(10px 10px 0 0);
        img {
            &:extend(.grabbingItem_img);
        }
    }

    .grabbingItem_start {
        .grabbingItem_left span {
            background: url(../../assets/images/activity/tag_4.png) no-repeat;
            background-size: 63px auto;
        }
        .join_grabbing {
            background: @bg-color;
        }
        .num_speed {
            width: 40%;
        }
    }

    .grabbingItem_end {
        .grabbingItem_left span {
            background: url(../../assets/images/activity/tag_3.png) no-repeat;
            background-size: 63px auto;
        }
        .join_grabbing {
            background: @green-color;
        }
        .num_speed {
            width: 0;
        }
    }

    .grabbingItem_left {
        float: left;
        width: 19%;
        span {
            .box-sizing;
            padding-top: 5px;
            height: 45px;
            width: 63px;
            line-height: 16px;
            font-size: .9rem;
            display: block;
            text-align: center;
            color: @font-primary;

        }
    }

    .grabbingItem_right {
        float: left;
        margin-left: 3%;
        width: 78%;
        letter-spacing: 1px;
        .grabbingItem_title {
            padding: 4px 0 10px 0;
            .border-bottom;
            margin-bottom: 10px;
            h2 {
                font-size: @font + .1;
                margin-bottom: .4rem;
            }
            p {
                color: @word;
                font-size: @font - .2;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
            }
        }
        .grabbingItem_time {
            & > p {
                color: @bg-color;
                font-size: .6rem;
                margin-bottom: 10px;
                i {
                    padding: 2px;
                    color: @font-primary;
                    background: @bg-color;
                }

            }
            .price {
                color: @bg-color;
                display: inline-block;
                height: 28px;
                font-size: @font * 2;
                position: relative;
                margin: 0 0 10px 10px;
                &:before {
                    content: '￥';
                    font-size: .8rem;
                    bottom: 0;
                    left: -13px;
                }
            }
            .join_grabbing {
                float: right;
                width: 35%;
                height: @width;
                color: @font-primary;
                font-size: .8rem;
                text-align: center;
                line-height: 28px;
            }
            .grabbing_num {
                font-size: .6rem;
                color: @word;
                p {
                    float: right;
                    .num {
                        margin-left: 5px;
                        display: inline-block;
                        width: 90px;
                        height: 8px;
                        position: relative;
                        .border-radius(10px);
                        background: @bg;
                        .num_speed {
                            position: absolute;
                            top: 0;
                            left: 0;
                            .border-radius(10px);
                            height: 8px;
                            display: block;
                            background: url("../../assets/images/activity/speed.png") no-repeat;

                        }
                    }

                }
            }

        }

    }
    @media (min-width: 768px) and (orientation: portrait){
        .grabbingItem_img {
            height: 343px;
            img {
                &:extend(.grabbingItem_img);
            }
        }

        .grabbingItem_start {
            .grabbingItem_left span {
                background: url(../../assets/images/activity/tag_4.png) no-repeat;
                background-size: 76px auto;
            }
            .num_speed {
                width: 40%;
            }
        }

        .grabbingItem_end {
            .grabbingItem_left span {
                background: url(../../assets/images/activity/tag_3.png) no-repeat;
                background-size: 76px auto;
            }
            .num_speed {
                width: 0;
            }
        }

        .grabbingItem_left {
            width: 17%;
            span {
                padding-top: 9px;
                height: 56px;
                width: 76px;
                line-height: 16px;
                font-size: 1rem;

            }
        }

        .grabbingItem_right {
            margin-left: 3%;
            width: 80%;
            letter-spacing: 1px;
            .grabbingItem_title {
                h2 {
                    font-size: @font + .2;
                }
                p {
                    font-size: @font ;
                }
            }
            .grabbingItem_time {
                & > p {
                    font-size: @font;
                    i {
                        padding: 3px;
                    }

                }
                .price {
                    height: 28px;
                    font-size: @font * 2;
                    &:before {
                        font-size: @font;
                    }
                }
                .join_grabbing {
                    width: 35%;
                    font-size: @font;
                }
                .grabbing_num {
                    font-size:@font;
                    p {
                        .num {
                            margin-left: 5px;
                            width: 128px;
                            height: 8px;
                            .num_speed {
                                position: absolute;
                                top: 0;
                                left: 0;
                                .border-radius(10px);
                                height: 8px;
                                display: block;
                                background: url("../../assets/images/activity/speed.png") no-repeat;

                            }
                        }

                    }
                }

            }

        }
    }

</style>
